import SupervisorSendItemsView from 'components/SendItems/SupervisorSendItemsView';

const SupervisorSendItems = () => {
  return <SupervisorSendItemsView backUrl="/sorumlu-olduklarim" />;
};

export default SupervisorSendItems;
